<template>
  <v-tooltip :text="tooltipText" location="top">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        icon
        variant="text"
        size="small"
        aria-label="Copy"
        class="clipboard-icon-button"
        :class="iconClass"
        @click="onCopy"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </template>
  </v-tooltip>
</template>

<script>
export default {
  name: 'ClipboardIconButton',

  props: {
    value: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      required: false,
      default: ''
    }
  },

  emits: ['copied', 'copy-failed'],

  data() {
    return {
      isCopied: false,
      timeoutId: null
    };
  },

  computed: {
    tooltipText() {
      return this.isCopied ? 'Copied!' : 'Copy to clipboard';
    }
  },

  beforeUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },

  methods: {
    async onCopy() {
      try {
        await navigator.clipboard.writeText(this.value);
        this.isCopied = true;
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
          this.isCopied = false;
        }, 2000);
        this.$emit('copied', this.value);
      } catch (error) {
        this.$emit('copy-failed', error);
      }
    }
  }
};
</script>

<style scoped>
.clipboard-icon-button {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 100ms;
  vertical-align: middle;
  margin-left: 4px;
}

.clipboard-icon-button:hover {
  opacity: 1;
  color: rgb(185, 28, 92);
}
</style>
